import { RecurlyApiContract } from "../../../contracts/recurly-api/recurly-api";

const getRecurlyPaymentToken = async (
  recurly: any,
  formRef: any
): Promise<any> => {
  let res;
  await new Promise((resolve, reject) => {
    try {
      recurly.token(
        formRef,
        (err: { code: any; fields: any }, token: { id: string }) => {
          res = recurlyTokenHandler(err, token);
          resolve(res);
        }
      );
    } catch (e) {
      reject();
    }
  });

  return res;

  // return new Promise((resolve) => {
  //     setTimeout(resolve, 3000);
  // }).then(() => {
  //     return { tokenId: '1234' };
  // });
};

function recurlyTokenHandler(
  err: { code: any; fields: any },
  token: { id: string }
) {
  if (err) {
    return err;
  } else {
    return { tokenId: token.id };
  }
}

const RecurlyApi: RecurlyApiContract = {
  getRecurlyPaymentToken,
};
export default RecurlyApi;
